// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "vocemaissaudavel-79cf1.firebaseapp.com",
  "projectId": "vocemaissaudavel-79cf1",
  "storageBucket": "vocemaissaudavel-79cf1.appspot.com",
  "messagingSenderId": "820244444067",
  "appId": "1:820244444067:web:83379b5394c80990606016",
  "measurementId": "G-QBWYZZBQDT",
  "apiKey": "AIzaSyBs1RHqdajSZjd9Gq-lzvZTxzQPqeo-QwU"
};
